import DataTableParametersDto from "./DataTableParametersDto";

abstract class DataTableReadDto {

    Parameters: DataTableParametersDto | null = null;

    public get Label(): string {
        return '';
    }

}

export default DataTableReadDto;